/* ---- Network Requests ---- */
async function getTradeinUuid() {
  // create a new tradein if the user hasn't already started one
  let tradeinUuid = localStorage.getItem('tradeinUuid');
  if (!tradeinUuid) {
    const tradeInSearchPathname = `${window.location.pathname.match(/.*pages/i)[0]}/trade-in-search`;
    location.href = tradeInSearchPathname;
    return;
  }
  return tradeinUuid;
}
